import { useMutation } from '@tanstack/react-query';

import { FetchOptions, useFetch } from './useFetch';

export function useApiMutation<TBody, TResponse = void>(
  url?: string,
  fetchOptions: FetchOptions = {},
  mutationOptions?: {
    onError?: (error: Error) => void;
    onSuccess?: (data: TResponse) => void;
  }
) {
  const fetchClient = useFetch();

  const mutation = useMutation<TResponse, undefined, TBody>({
    mutationFn: (body) => {
      if (!url) {
        return undefined;
      }

      return fetchClient(url, { ...fetchOptions, body: JSON.stringify(body) });
    },
    ...mutationOptions,
  });

  return mutation;
}
